/**
 * Enum representing button types available in Angular Material.
 * - `BASIC`: Basic button style.
 * - `RAISED`: Raised button with an elevated appearance.
 * - `STROKED`: Button with a stroked outline.
 * - `FLAT`: Flat button with no elevation.
 * - `ICON`: Button with an icon.
 * - `FAB`: Floating action button.
 * - `MINI_FAB`: Mini floating action button.
 *
 * For further information, https://material.angular.io/components/button/overview
 */
export enum MatButtonAvailableType {
    BASIC = 'BASIC',
    RAISED = 'RAISED',
    STROKED = 'STROKED',
    FLAT = 'FLAT',
    ICON = 'ICON',
    FAB = 'FAB',
    MINI_FAB = 'MINI_FAB',
}
